import * as PIXI from "pixi.js";
import data from "../configs/data";
import {ProgressBar} from "./ProgressBar";

export class LoadingScreen extends PIXI.Container {

    private readonly PROGRESS_BAR_POS = new PIXI.Point(277, 528);
    private readonly CASINO_LOGO_POS = new PIXI.Point(640, 270);

    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);

    private progressBar: ProgressBar;

    constructor() {
        super();
        this.createAndAddProgressBar();
        this.createAndAddLogo();
    }

    public updateProgressBarValue(progressInPercents: number): void {
        this.progressBar.updateValue(progressInPercents);
    }

    private createAndAddLogo(): void {
        const logo = PIXI.Sprite.fromImage(data.loadingScreen.images.loadingScreenLogo);
        logo.position = this.CASINO_LOGO_POS;
        logo.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(logo);
        (window as any).logo = logo;
    }

    private createAndAddProgressBar(): void {
        this.progressBar = new ProgressBar();
        this.progressBar.position = this.PROGRESS_BAR_POS;
        this.addChild(this.progressBar);
        (window as any).progressBar = this.progressBar;
    }
}



// WEBPACK FOOTER //
// ./src/app/loadingScreen/LoadingScreen.ts